'use strict';

var isExternalUrl = {};

exports.__exports = isExternalUrl;
//# sourceMappingURL=isExternalUrl.cjs.map
